"use strict";
var actionTypes_1 = require('../actions/actionTypes');
var genId = function () {
    return Math.random().toString(36).slice(-10);
};
var createNotification = function (state, _a) {
    var type = _a.type, message = _a.message;
    var id = genId();
    return [{
        id: id,
        type: type,
        message: message
    }].concat(state);
};
exports.showupReducer = function (state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case actionTypes_1.ADD_ALERT_NOTIFICATION:
            return createNotification(state, { type: 'alert', message: action.payload });
        case actionTypes_1.ADD_ERROR_NOTIFICATION:
            return createNotification(state, { type: 'error', message: action.payload });
        case actionTypes_1.CLEAR_NOTIFICATION:
            return state.filter(function (noti) { return noti.id !== action.payload; });
        default:
            return state;
    }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/notification.ts
 ** module id = 241
 ** module chunks = 0
 **/